var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "seeker-education" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-default-6 col-v-tablet-12" },
        [
          _c("z-date-picker", {
            ref: "study-period",
            attrs: {
              range: "",
              "value-type": "format",
              placeholder: "Период обучения*",
              required: "",
              name: "study-period",
            },
            model: {
              value: _vm.params["study-period"],
              callback: function ($$v) {
                _vm.$set(_vm.params, "study-period", $$v)
              },
              expression: "params['study-period']",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-default-6 col-v-tablet-12" },
        [
          _c("z-input", {
            ref: "university",
            attrs: {
              placeholder: "Учебное заведение*",
              name: "university",
              required: "",
            },
            model: {
              value: _vm.params.university,
              callback: function ($$v) {
                _vm.$set(_vm.params, "university", $$v)
              },
              expression: "params.university",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-default-6 col-v-tablet-12" },
        [
          _c("z-input", {
            ref: "specialization",
            attrs: {
              placeholder: "Специальность*",
              name: "specialization",
              required: "",
            },
            model: {
              value: _vm.params.specialization,
              callback: function ($$v) {
                _vm.$set(_vm.params, "specialization", $$v)
              },
              expression: "params.specialization",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }